import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  makeStyles,
} from "@material-ui/core";
import { Field, useFormikContext } from "formik";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import DayJsUtils from "@date-io/dayjs";
import { Autocomplete as FormikAutocomplete } from "formik-material-ui-lab";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from "dayjs";
import { fetchSectors } from "../../../services/sectorService";
import localeEl from "dayjs/locale/el";
import localeEn from "dayjs/locale/en";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useState } from "react";
import GovGrButton from "../../../components/GovGrButton";

const useStyles = makeStyles({
  dialog: {},
  dateContainer: {
    width: "100%",
  },
});

const SectorModal = ({
  open,
  close,
  refetch,
  values,
  submit,
  setFieldValue,
}) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t, locale } = useLocale();
  dayjs().locale(locale === "el-GR" ? localeEl : localeEn);
  const { touched, errors } = useFormikContext();
  const { data: sectors } = useQuery("sectors", fetchSectors);

  return (
    <MuiPickersUtilsProvider
      locale={locale === "el-GR" ? localeEl : localeEn}
      utils={DayJsUtils}
    >
      <CustomDialog
        open={open}
        maxWidth="sm"
        onClose={() => {
          close();
          setError("");
        }}
      >
        <DialogTitle id="form-dialog-title">{t("Sector")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("Please select a Sector")}</DialogContentText>
        </DialogContent>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />

        <DialogContent className={classes.dialog}>
          <div className={classes.dateContainer}>
            <Field
              name="sector_id"
              component={FormikAutocomplete}
              options={sectors || []}
              getOptionLabel={(option) => option?.dscr}
              renderInput={(params) => (
                <TextField
                  style={{ minWidth: 500, width: 500 }}
                  required
                  {...params}
                  error={touched["sector_id"] && !!errors["sector_id"]}
                  helperText={touched["sector_id"] && errors["sector_id"]}
                  label={t("Sector")}
                  variant="outlined"
                  margin="normal"
                />
              )}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <GovGrButton
            onClick={() => {
              submit();
              close();
            }}
            color="primary"
            buttonText={t("Change application status")}
          />

          <GovGrButton
            onClick={() => {
              close();
              setError("");
              setFieldValue("sector_id", null);
            }}
            color="primary"
            buttonText={t("Cancel")}
          />
        </DialogActions>
      </CustomDialog>
    </MuiPickersUtilsProvider>
  );
};

export default SectorModal;
